module.exports = __webpack_public_path__ + "static/media/textoDinamico.850b8435.jpg";